import { ReactComponent as IconRightArrow } from "@/assets/svgs/chevron-right-small.svg";
import MultiLevelDropDown from "./index";

function menuButton(item) {
	return (
		<div className="menu-dropdown__menu-item-contents">
			<div
				className="menu-item__label"
				style={{ color: `${item.labelColor}` }}
			>
				{item.label}
			</div>
			<div className="menu-dropdown__menu-arrow">
				<IconRightArrow />
			</div>
		</div>
	);
}

export default function MenuItems({ item, hide, closeAll, setCloseAll }) {
	return (
		<>
			{item && <div className="menu-dropdown__menu-item">
				{item.submenu && (
					<>
						<MultiLevelDropDown
							menuList={item.submenu}
							button={() => menuButton(item)}
							placement="right-start"
							modifiers={[
								{
									name: "offset",
									options: { offset: [-5, 8] },
								},
							]}
							closeAll={closeAll}
							setCloseAll={setCloseAll}
						/>
					</>
				)}
				{!item.submenu && (
					<>
						<div
							className="menu-dropdown__menu-item-contents"
							onClick={(e) => {
								item?.onClick(e);
								hide();
							}}
						>
							{item.icon && (
								<div className="menu-dropdown__item-icon">
									{item.icon}
								</div>
							)}

							<div
								className="menu-dropdown__item-label"
								style={{ color: `${item.labelColor}` }}
							>
								{item.label}
							</div>
						</div>
					</>
				)}
			</div>}
		</>
	);
}
